import React from "react";
import { Link } from "react-router";

function Properties() {
  return (
    <div>
      <div className="properties section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 offset-lg-4">
              <div className="section-heading text-center">
                <h6>| Properties</h6>
                <h2>We Provide The Best Property You Like</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="item">
                <a>
                  <img src="assets/images/property-01.jpg" alt="" />
                </a>
                <span className="category">Luxury Villa</span>
                <h6>$2.264.000</h6>
                <h4>
                  <a href="property-details.html">
                    18 New Street Miami, OR 97219
                  </a>
                </h4>
                <ul>
                  <li>
                    Bedrooms: <span>8</span>
                  </li>
                  <li>
                    Bathrooms: <span>8</span>
                  </li>
                  <li>
                    Area: <span>545m2</span>
                  </li>
                  <li>
                    Floor: <span>3</span>
                  </li>
                  <li>
                    Parking: <span>6 spots</span>
                  </li>
                </ul>
                
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item">
                <a >
                  <img src="assets/images/property-02.jpg" alt="" />
                </a>
                <span className="category">Luxury Villa</span>
                <h6>$1.180.000</h6>
                <h4>
                  <a href="property-details.html">
                    54 Mid Street Florida, OR 27001
                  </a>
                </h4>
                <ul>
                  <li>
                    Bedrooms: <span>6</span>
                  </li>
                  <li>
                    Bathrooms: <span>5</span>
                  </li>
                  <li>
                    Area: <span>450m2</span>
                  </li>
                  <li>
                    Floor: <span>3</span>
                  </li>
                  <li>
                    Parking: <span>8 spots</span>
                  </li>
                </ul>
                
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item">
                <a >
                  <img src="assets/images/property-03.jpg" alt="" />
                </a>
                <span className="category">Luxury Villa</span>
                <h6>$1.460.000</h6>
                <h4>
                  <a href="property-details.html">
                    26 Old Street Miami, OR 38540
                  </a>
                </h4>
                <ul>
                  <li>
                    Bedrooms: <span>5</span>
                  </li>
                  <li>
                    Bathrooms: <span>4</span>
                  </li>
                  <li>
                    Area: <span>225m2</span>
                  </li>
                  <li>
                    Floor: <span>3</span>
                  </li>
                  <li>
                    Parking: <span>10 spots</span>
                  </li>
                </ul>
               
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item">
                <a >
                  <img src="assets/images/property-04.jpg" alt="" />
                </a>
                <span className="category">Apartment</span>
                <h6>$584.500</h6>
                <h4>
                  <a href="property-details.html">
                    12 New Street Miami, OR 12650
                  </a>
                </h4>
                <ul>
                  <li>
                    Bedrooms: <span>4</span>
                  </li>
                  <li>
                    Bathrooms: <span>3</span>
                  </li>
                  <li>
                    Area: <span>125m2</span>
                  </li>
                  <li>
                    Floor: <span>25th</span>
                  </li>
                  <li>
                    Parking: <span>2 cars</span>
                  </li>
                </ul>
                
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item">
                <a >
                  <img src="assets/images/property-05.jpg" alt="" />
                </a>
                <span className="category">Penthouse</span>
                <h6>$925.600</h6>
                <h4>
                  <a href="property-details.html">
                    34 Beach Street Miami, OR 42680
                  </a>
                </h4>
                <ul>
                  <li>
                    Bedrooms: <span>4</span>
                  </li>
                  <li>
                    Bathrooms: <span>4</span>
                  </li>
                  <li>
                    Area: <span>180m2</span>
                  </li>
                  <li>
                    Floor: <span>38th</span>
                  </li>
                  <li>
                    Parking: <span>2 cars</span>
                  </li>
                </ul>
               
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="item">
                <a >
                  <img src="assets/images/property-06.jpg" alt="" />
                </a>
                <span className="category">Modern Condo</span>
                <h6>$450.000</h6>
                <h4>
                  <a href="property-details.html">
                    22 New Street Portland, OR 16540
                  </a>
                </h4>
                <ul>
                  <li>
                    Bedrooms: <span>3</span>
                  </li>
                  <li>
                    Bathrooms: <span>2</span>
                  </li>
                  <li>
                    Area: <span>165m2</span>
                  </li>
                  <li>
                    Floor: <span>26th</span>
                  </li>
                  <li>
                    Parking: <span>3 cars</span>
                  </li>
                </ul>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Properties;
